import styled from "@emotion/styled"
import { blendWithWhiteBackground } from "../../../util"
import { Text, Button, StylesProps } from "../../styles/common.styled"

export const Overlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`
export const Modal = styled.div<StylesProps>`
  width: 100%;
  padding: 1rem;
  border-radius: 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  border: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorder
      ? `2px solid ${roomStyles?.servicePanelElementBorder}`
      : "2px solid #ced4da"};
  background-color: ${({ roomStyles }) =>
    blendWithWhiteBackground(roomStyles?.servicePanelElementModalBackground) ??
    "white"};
`

export const Title = styled(Text)<StylesProps>`
  text-align: center;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText &&
    roomStyles?.servicePanelElementPrimaryText};
`

export const CloseButton = styled(Button)<StylesProps>`
  background-color: ${({ roomStyles }) =>
    roomStyles.closeButtonBackgroundColor || "#fff"};
  color: ${({ roomStyles }) => roomStyles.joinPageButtonTextColor || "#fff"};
  &:hover {
    background-color: ${({ roomStyles }) =>
      roomStyles.closeButtonMouseoverBackgroundColor || "#fff"};
    color: ${({ roomStyles }) =>
      roomStyles.joinPageButtonMouseoverTextColor || "#fff"};
  }
`
